import * as R from 'ramda';

// updateAtId takes an id and Ramda transform function
// applies transformation to object in list with id
// example... updateAtId(itemId, R.assoc('flag', true))(items)
export const updateAtId = (id, transform) => R.map(R.when(R.propEq(id, 'id'), transform));
